// URL of a file under client/public/assets, honouring the CRA public path.
export const publicAsset = (name) => `${process.env.PUBLIC_URL || ""}/assets/${name}`;
